<p-dialog
  closeOnEscape="false"
  class="filters-modal"
  [header]="'Transacciones - ' + (card?.alias || card?.last4 || '')"
  [modal]="true"
  [(visible)]="showTransactions"
  [style]="{ width: '980px' }"
  *ngIf="showTransactions"
  (visibleChange)="exitView()"
>
  <div class="transactions-filters">
    <div class="input-item">
      <label for="card_tx_from">Desde</label>
      <input
        id="card_tx_from"
        type="date"
        pInputText
        [(ngModel)]="fromDate"
        [disabled]="loading"
      />
    </div>
    <div class="input-item">
      <label for="card_tx_to">Hasta</label>
      <input
        id="card_tx_to"
        type="date"
        pInputText
        [(ngModel)]="toDate"
        [disabled]="loading"
      />
    </div>
    <div class="input-item operations">
      <label for="card_tx_operations">Operaciones</label>
      <p-multiSelect
        inputId="card_tx_operations"
        [options]="operationOptions"
        [(ngModel)]="selectedOperations"
        optionLabel="name"
        optionValue="code"
        placeholder="Todas"
        [disabled]="loading"
        appendTo="body"
        [style]="{ width: '100%' }"
      />
    </div>
    <p-button
      label="Buscar"
      severity="secondary"
      [disabled]="loading"
      (click)="refresh()"
    />
  </div>

  <div class="transactions-table">
    <div class="empty-space" *ngIf="!loading && !transactions.length">
      No se encontraron transacciones para mostrar
    </div>

    <p-table
      *ngIf="!loading && transactions.length"
      [scrollable]="true"
      [scrollHeight]="'420px'"
      styleClass="p-datatable-striped p-datatable-sm"
      [value]="transactions"
      [tableStyle]="{ 'min-width': '48rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Fecha</th>
          <th>Operación</th>
          <th>Comercio</th>
          <th>Monto</th>
          <th>Detalle</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-movement>
        <tr>
          <td class="is-date">
            <ng-container *ngIf="movementDate(movement); else noDate">
              {{ utilsService.formatDate(movementDate(movement)) }}
              <br />
              {{ utilsService.formatHour(movementDate(movement)) }}
            </ng-container>
            <ng-template #noDate>—</ng-template>
          </td>
          <td class="status">
            <div
              class="ts-status"
              [class.finished]="operationStatusClass(movement) === 'finished'"
              [class.processing]="operationStatusClass(movement) === 'processing'"
              [class.cancelled]="operationStatusClass(movement) === 'cancelled'"
            >
              {{ operationLabel(movement) }}
            </div>
          </td>
          <td>{{ merchantName(movement) }}</td>
          <td>
            <ng-container *ngIf="movementAmount(movement) !== null; else noAmount">
              {{ movementAmount(movement) | number: "1.2-8" }}
              {{ movementCurrency(movement) }}
            </ng-container>
            <ng-template #noAmount>—</ng-template>
          </td>
          <td>
            <span *ngIf="declinedReason(movement)">{{ declinedReason(movement) }}</span>
            <span *ngIf="!declinedReason(movement) && movement.original_balance != null">
              {{ movement.original_balance | number: "1.2-8" }}
              →
              {{ movement.new_balance | number: "1.2-8" }}
            </span>
            <span *ngIf="!declinedReason(movement) && movement.original_balance == null">
              —
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="paginator" *ngIf="!loading">
      <div class="paginator-total">
        {{ total }}
        {{ total === 1 ? "transacción" : "transacciones" }} en total
      </div>
      <div class="paginator-buttons">
        <div class="limit">
          <p-dropdown
            [options]="limitSelectorValues"
            (onChange)="changeLimit($event)"
            optionLabel="name"
            [disabled]="loading"
            [class.disabled]="loading"
            [(ngModel)]="limitSelected"
          ></p-dropdown>
        </div>
        <div
          class="paginator-button"
          [class.disabled]="offset === 1 || loading"
          (click)="previousPage()"
        >
          <i class="pi pi-angle-left"></i>
        </div>
        <div
          class="paginator-button"
          (click)="loadTransactions()"
          [class.disabled]="loading"
        >
          <i class="pi pi-refresh"></i>
        </div>
        <div
          class="paginator-button"
          [class.disabled]="atLastPage() || loading"
          (click)="nextPage()"
        >
          <i class="pi pi-angle-right"></i>
        </div>
      </div>
    </div>

    <app-loading
      [loadingText]="'Cargando transacciones'"
      *ngIf="loading"
    />
  </div>

  <div class="buttons-container">
    <p-button label="Cerrar" severity="danger" (click)="exitView()" />
  </div>
</p-dialog>
